import { BaseProvider } from "./base.provider";
export class HabaneroProvider extends BaseProvider {
    init() {
        // nothing to be done
    }
}
